import { render, staticRenderFns } from "./firstLoginPage.vue?vue&type=template&id=036e02fe&scoped=true"
import script from "./firstLoginPage.vue?vue&type=script&lang=js"
export * from "./firstLoginPage.vue?vue&type=script&lang=js"
import style0 from "./firstLoginPage.vue?vue&type=style&index=0&id=036e02fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e02fe",
  null
  
)

export default component.exports